import React, { useState } from "react";
import Replicate_Testing_Filter from "./replicate_testing_filter/Replicate_Testing_Filter";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Replicate_Testing_Table from "./replicate_testing_table/Replicate_Testing_Table";

const Replicate_Testing = () => {
  const [show, setShow] = useState(false);

  return (
    <section className="Sample_Report">
    

      <div className="Sample_Report_Filter_div">
        <Replicate_Testing_Filter setShow={setShow} />
      </div>

      <div className="report_table_div">
        <Replicate_Testing_Table />
      </div>

      <Common_Report_Offcanvas
        title={"Measurement Uncertainty Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Replicate_Testing;
